export default __webpack_public_path__ + "static/media/screenForbidden.8360d472.svg";